'use client';

import {
  AppleIcon,
  ChromeIcon,
  McpIcon,
  MpIcon,
  WindowsIcon,
} from '@/components/icons';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { MCP_URL } from '@/lib/constants';
import { useAuth } from '@/providers/auth-provider';
import AdBanner from '@/components/ad-banner';
import { DownloadIcon, GemIcon, UserIcon } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import UserDropdown from './top-menu-user-dropdown';

const TopMenu = () => {
  const { loading, user, triggerLogin, showActivateCardModal } = useAuth();
  const [isOpenMp, setIsOpenMp] = useState(false);

  return (
    <div className="sticky top-0 z-40 inset-0 h-11 py-1 flex items-center px-2 pr-2 md:pr-2 md:pl-1 bg-sidebar border-b">
      <div className="absolute h-px bg-border "></div>
      <SidebarTrigger className="mr-2" />
      <div className="flex-1">
        <div className="hidden lg:block">
          <AdBanner />
        </div>
      </div>
      <div className="items-center shrink-0 gap-x-2 flex">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              size="sm"
              variant="outline"
              className="hidden md:flex h-7 text-xs"
            >
              <DownloadIcon className="w-3 h-3" />
              应用&插件
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="shadow-none rounded-lg">
            <DropdownMenuItem asChild>
              <Link href="/landing/zotero">
                <Image
                  src="/img/zotero-logo.png"
                  width={16}
                  height={16}
                  alt="Suppr Zotero 插件"
                  className="mr-2"
                  sizes="16px"
                />
                Zotero 插件
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <a
                href="https://www.wilddata.cn/1supprextension/"
                target="_blank"
              >
                <ChromeIcon className="mr-2 h-4 w-4" />
                浏览器插件
              </a>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <a
                href="https://www.wilddata.cn/1suppraiwindowsmac/"
                target="_blank"
              >
                <AppleIcon className="mr-2 h-4 w-4" />
                Mac 客户端
              </a>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <a
                href="https://www.wilddata.cn/1suppraiwindowsmac/"
                target="_blank"
              >
                <WindowsIcon className="mr-2 h-4 w-4" />
                Win 客户端
              </a>
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setIsOpenMp(true)}>
              <MpIcon className="mr-2 h-4 w-4" />
              微信小程序
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <a href={MCP_URL} target="_blank">
                <McpIcon className="mr-2 h-4 w-4" />
                MCP 服务
              </a>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        {user &&
          user.pointInfo?.queued_cards &&
          user.pointInfo.queued_cards.length > 0 &&
          user.pointInfo?.can_activate_card && (
            <Button
              size="sm"
              variant="outline"
              className="hidden md:flex h-7 text-xs"
              onClick={showActivateCardModal}
            >
              <GemIcon className="w-4 h-4 text-neutral-600 dark:text-neutral-200" />
              激活会员卡
            </Button>
          )}
        {user && !user.membership && (
          <Button
            size="sm"
            variant="outline"
            className="hidden md:flex h-7 text-xs"
            asChild
          >
            <Link href="/pricing/subscribe">
              <GemIcon className="w-4 h-4 text-neutral-600 dark:text-neutral-200" />
              升级会员
            </Link>
          </Button>
        )}
        {loading ? (
          <Avatar className="h-7 w-7 bg-neutral-300 dark:bg-neutral-700">
            <AvatarFallback className="bg-neutral-300 dark:bg-neutral-700"></AvatarFallback>
          </Avatar>
        ) : user ? (
          <UserDropdown user={user} />
        ) : (
          <Button
            size="sm"
            className="h-7 text-xs"
            onClick={() => triggerLogin && triggerLogin()}
          >
            <UserIcon className="w-3 h-3" />
            <span className="text-base md:text-sm">登录</span>
          </Button>
        )}
      </div>
      <Dialog open={isOpenMp} onOpenChange={setIsOpenMp}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-lg text-center">
              Suppr 微信小程序
            </DialogTitle>
          </DialogHeader>
          <div className="p-4 pb-8">
            <div className="flex justify-center">
              <Image
                alt="微信小程序"
                width={258}
                height={258}
                src="/img/gh_21d610166629_430.jpg"
                className="rounded-lg"
                sizes="258px"
              />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default TopMenu;
